import sectionCardBasicB1Css from '../css-snippets/section-card-basic-b1';

const html = `
<style>${sectionCardBasicB1Css}</style>
<div class="wrapper-container" id="" data-id="uawgo3" data-attribute="wrapper-container" data-text-color="#ffffff"
  data-background-color="#281707" data-top-padding="true" data-bottom-padding="true"
  style="background-color: rgb(40, 23, 7); color: rgb(255, 255, 255); --text-color: #ffffff;">
  <div class="container wrapper-content">
    <div data-attribute="left-group" data-show-left-group="true" data-order="1" class="left-group">
      <div class="wrap-icon-img" data-show-icon="true" data-attribute="wrap-icon-img">
        <img
          src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a4a85800cd816ffe37930.png?w=50&amp;h=50&amp;q=80"
          alt="">
      </div>
      <div class="text-content" data-show-text="true" data-attribute="text-content-primary">
        <h2>Risk-Free for 100 Days</h2>
        <p>We're confident you'll love your Kaliqo lights. If not, return them within 100 days for a full refund. No
          questions asked.</p>
      </div>
    </div>
    <div data-attribute="right-group" data-show-right-group="true" data-order="2" class="right-group">
      <div class="text-content-secondary" data-show-text="true" data-attribute="text-content-secondary">
        <h3>Text content secondary</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
      </div>
      <div class="wrap-button" data-attribute="wrap-button">
        <a data-attribute="button-link" data-show-btn="true" data-background-color="#aa6d32" data-color="#ffffff"
          href="#" style="background-color: #aa6d32; color: #ffffff;">LIGHTEN UP YOUR SPACE NOW</a>
        <div class="sub-btn" data-attribute="sub-btn">🚛 Get faster shipping when you buy 2+</div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
